var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{staticClass:"mt-2",attrs:{"striped":"","hover":"","fields":_vm.fields,"items":_vm.rows}})
}
var staticRenderFns = []

export { render, staticRenderFns }